import { Box, Button, Stack, TextField, Typography } from '@mui/material';

import { generatePassword } from './generatePassword';

/**
 * A generated password, shown so it can be passed on.
 *
 * It is visible rather than masked, deliberately. The administrator setting it is the person who has to
 * tell somebody else what it is, and a field they cannot read is a field they will paste somewhere worse
 * to read it.
 *
 * There is no "copy" button. The clipboard needs a permission prompt in some browsers and fails silently
 * in others, and a button that sometimes does nothing is worse than selecting the text.
 */
export const PasswordField = ({ value, onChange }: { value: string; onChange: (next: string) => void }) => (
  <Box>
    <Stack direction="row" spacing={1} alignItems="flex-start">
      <TextField
        fullWidth
        label="Heslo"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        inputProps={{ style: { fontFamily: 'ui-monospace, monospace' } }}
      />
      <Button sx={{ mt: 1, flexShrink: 0 }} onClick={() => onChange(generatePassword())}>
        Vygenerovať
      </Button>
    </Stack>
    <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
      Zobrazuje sa iba teraz — odovzdajte ho skôr, než dialóg zavriete. Uložené je len ako hash.
    </Typography>
  </Box>
);
